import React from 'react'
import Flashcomponet from '../components/Flashcomponents/Flashcomponet'
import NewProducts from '../components/NewArival/NewProducts'
import AllBrand from '../components/Brands/AllBrand'
import Footer from '../components/Brands/footer/footer'

import Carousel from '../components/HeroSection.jsx/Carousel'

function Home() {
  

	
  return (
    <>
    <Carousel/>
<Flashcomponet/>
<NewProducts/>
<AllBrand/>

<Footer/>

    </>
  )
}

export default Home